LevelConstants =
  levels:
    'dungeons-of-kithgard': '5411cb3769152f1707be029c'
    'defense-of-plainswood': '541b67f71ccc8eaae19f3c62'
    'the-gem': '65c55febd2ca2055e6566b2b'

  lowerIsBetterScoreTypes: ['time', 'damage-taken', 'code-length']

module.exports = LevelConstants
